import Store from '@/store'

export class PackageStoreUtils {

    static getNewPackage() {
        return Store.dispatch("package-store/getNewPackage");
    }

    static fethPackages() {
        return Store.dispatch("package-store/fethPackages");
    }

    static fethPackageFile(packageId, fileName) {
        return Store.dispatch("package-store/fethPackageFile", {packageId, fileName});
    }

    static deployPackage(data) {
        return Store.dispatch("package-store/deployPackage", data);
    }

    static uploadPackageFile(data) {
        return Store.dispatch("package-store/uploadPackageFile", data);
    }

    static deletePackageFile(packageId, fileName) {
        return Store.dispatch("package-store/deletePackageFile", {packageId, fileName});
    }

    static fethPackageContent(packageId) {
        return Store.dispatch("package-store/fethPackageContent", packageId);
    }

    static deletePackage(packageId) {
        return Store.dispatch("package-store/deletePackage", packageId);
    }

    static updatePackage(data) {
        return Store.dispatch("package-store/updatePackage", data);
    }

    static fethDeployedPackageList() {
        return Store.dispatch("package-store/fethDeployedPackageList");
    }

    static setDeployedPackageAudience(data) {
        return Store.dispatch("package-store/setDeployedPackageAudience", data);
    }

    static setDeployedPackageClientVersion(data) {
        return Store.dispatch("package-store/setDeployedPackageClientVersion", data);
    }

    static removeDeployedPackage(name) {
        return Store.dispatch("package-store/removeDeployedPackage", name);
    }

    //GETTERS
    static getPackages() {
        return Store.getters["package-store/getPackages"];
    }

    static getDeployedPackages() {
        return Store.getters["package-store/getDeployedPackages"];
    }

    /*



    static removeMap(mapId) {
        return Store.dispatch("maps-backend/removeMap", mapId);
    }

    static setMapAudience(value) {
        return Store.dispatch("maps-backend/setMapAudience", value);
    }

    static setMapClientVersion(value) {
        return Store.dispatch("maps-backend/setMapClientVersion", value);
    }

    static duplicateMap(mapName) {
        return Store.dispatch("maps-backend/duplicateMap", mapName);
    }

    static getMap(mapName) {
        return Store.dispatch("maps-backend/getMap", mapName);
    }

    //GETTERS
    static getMaps() {
        return Store.getters["maps-backend/getMaps"];
    }*/
    //
    // static deployConfig(value, uid) {
    //     return Store.dispatch("backend-store/deployConfig", {value, uid});
    // }
}